"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Top5Comparison = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var axios_1 = __importDefault(require("axios"));
exports.Top5Comparison = React.memo(function (_a) {
    var active = _a.active, setActive = _a.setActive, activeFactor = _a.activeFactor, isBiggerBetter = _a.isBiggerBetter, respondentType = _a.respondentType, comparisonMunicipalitiesDispatch = _a.comparisonMunicipalitiesDispatch, groupingService = _a.groupingService;
    react_1.useEffect(function () {
        if (active === 'top') {
            var passRespondentTypeIfSurvey = groupingService.getFactorGroup(activeFactor) === 'survey';
            // We have survey charts showing both respondent types. Which means that respondent type is null. However,
            // we need a non-null respondentType to retrieve a correct Top 5 factors so we simply send 'Företagare' if we
            // must send something when it's undefined.
            var type = passRespondentTypeIfSurvey
                ? (respondentType !== null && respondentType !== void 0 ? respondentType : 'Företagare')
                : undefined;
            axios_1.default.get("/ranking/" + activeFactor + "/top", {
                params: {
                    type: type,
                    sortOrder: isBiggerBetter === undefined ? undefined : (isBiggerBetter ? "descending" : "ascending")
                }
            }).then(function (r) {
                var response = r.data;
                var municipalities = response.map(function (_a) {
                    var name = _a.name;
                    return name;
                });
                comparisonMunicipalitiesDispatch(['SET', municipalities]);
            })
                .catch(function (err) { return console.error(err); });
        }
    }, [active, activeFactor, isBiggerBetter, respondentType, comparisonMunicipalitiesDispatch, groupingService]);
    var onClick = function () {
        setActive('top');
    };
    return (React.createElement("li", { className: active === 'top' ? 'active' : '' },
        React.createElement("a", { onMouseDown: onClick },
            React.createElement("span", null, "Topp 5 inom m\u00E4tv\u00E4rdet"),
            React.createElement("i", { className: "fas fa-chevron-" + (active === 'top' ? "up" : "down") }))));
});
